<template>
  <div>
    <el-dialog :visible.sync="dialogListVisible" z-index="1000" width="300px" :destroy-on-close="true">
      <el-table style="width: 100%; margin-top: 20px;"
                :data="tableDataTwo"
                element-loading-text="数据处理中...请稍等...">
        <el-table-column prop="url" label="巡查照片" align="center">
          <template slot-scope="scope">
            <div style="color: #2b68e4; cursor:pointer;" @click="handlePictureCardPreview(scope.row.url)">图片.jpg</div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" z-index="1100" :destroy-on-close="true">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "PreviewXcImage",
    data () {
      return {
        dialogImageUrl: '',
        dialogListVisible: false,
        dialogVisible: false,
        tableDataTwo: [],
      }
    },
    methods: {
      handlePictureCardPreview: function (url) {
        this.dialogImageUrl = url;
        this.dialogVisible = true;
      },
      requestImageData: function (uuid) {
        let _this = this;
        let method = 'fjcx';
        // 3、 调接口获取数据
        let param = {
          baseService: _this.GLOBAL.config.baseServiceType.TGcFjServiceImpl,
          Personnel: {
            uuid: uuid
          }
        }
        _this.FUNCTIONS.systemFunction.interactiveData(
          _this,
          _this.GLOBAL.config.businessFlag.zxUser,
          method,
          param,
          null,
          resultData => {
            // _this.loading = false
            if (resultData) {
              _this.dialogListVisible = true
              // 数据处理
              this.dealData(resultData.obj)
            } else {
              _this.$message.warning('获取图片数据失败～')
            }
          },
          () => {
            // _this.loading = false
          }
        )
      },
      dealData: function (list) {
        this.tableDataOne = []
        this.tableDataTwo = []
        list.forEach(item => {
          this.tableDataTwo.push(item)
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PreviewXcImage.vue